import { apiConfig } from '@/lib/env';
/**
 * Development utility to warn about direct fetch usage
 * This helps ensure all API calls go through the centralized apiClient
 */

const originalFetch = window.fetch;

// Override fetch in development to warn about direct usage
if (import.meta.env.DEV) {
  window.fetch = function(...args) {
    const url = args[0];
    const options = args[1];
    
    // Allow fetch in apiClient and for external URLs
    if (
      typeof url === 'string' && (
        url.startsWith('http') || // External URLs
        url.startsWith('/api/') || // Legacy API paths (to be migrated)
        url.includes('localhost') || // Dev server
        url.includes('127.0.0.1') // Local dev
      )
    ) {
      // Check if this looks like an internal API call without auth
      if (typeof url === 'string' && url.includes('api.at-work.biz')) {
        const headers = options?.headers || {};
        const headerEntries = headers instanceof Headers 
          ? Array.from(headers.keys()) 
          : Object.keys(headers);
        const hasAuth = headerEntries.some(key => 
          key.toLowerCase() === 'authorization'
        );
        
        if (!hasAuth) {
          console.warn(`⚠️ Direct fetch() to API without auth detected: ${url}`);
          console.warn('💡 Consider using apiClient.get/post/put/delete for automatic auth headers');
          console.trace('Call stack:');
        }
      }
    }
    
    return originalFetch.apply(this, args);
  };
  
  console.log('🔧 Fetch interceptor enabled for development');
}

// Prod + dev: attach the JWT to raw fetch() calls to our own API that forgot it.
// Backend requires auth on lead/pipeline/scheduler routes. Never sent to other origins.
{
  const innerFetch = window.fetch;
  const apiOrigin = (() => {
    try { return new URL(apiConfig.baseUrl, window.location.origin).origin; } catch { return null; }
  })();
  window.fetch = function(input: RequestInfo | URL, init?: RequestInit) {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : null;
    const token = localStorage.getItem('token');
    if (url && token && apiOrigin && new URL(url, window.location.origin).origin === apiOrigin) {
      const headers = new Headers(init?.headers);
      if (!headers.has('Authorization')) {
        headers.set('Authorization', `Bearer ${token}`);
        init = { ...init, headers };
      }
    }
    return innerFetch.call(this, input as any, init);
  };
}

export {};